function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveCashBooking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3590.8918,
    y1: 4076.0273,
    x2: 1125.7065,
    y2: 1014.4221
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2916.713,2865.863c-56.844,59.46-110.629,97.805-153.124,128.101 c-499.518,356.117-1090.58,252.311-1216.198,226.96c-185.498-37.434-544.06-109.794-803.294-412.698 c-392.2-458.268-331.129-1180.257-26.912-1656.852c55.646-87.177,349.585-571.032,947.013-648.627 c361.557-46.96,783.017,47.752,1088.226,301.821C3393.086,1337.881,3347.478,2415.269,2916.713,2865.863z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M3201.227,500.935c3.406-14.501-16.992-24.14-29.483-14.01 c-126.841,102.855-431.602,410.86-355.65,949.121c95.293,675.328-67.622,921.75-270.412,1072.063 c0,0,278.498-70.687,453.715-320.734C3429.597,1573.449,3140.658,758.767,3201.227,500.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M3104.699,711.867c-15.868,75.181-30.01,150.592-40.939,226.342 c-11.388,75.687-20.114,151.637-26.085,227.714c-5.633,76.089-9.612,152.258-9.838,228.46 c-0.623,76.197,2.545,152.332,6.035,228.763c2.994,76.404,6.513,153.358,0.92,230.858c-5.5,77.342-21.78,155.359-54.086,228.495 c-8.076,18.227-16.568,36.398-26.215,53.956c-9.275,17.72-19.46,35.09-30.002,52.295c-21.286,34.328-45.248,67.495-71.95,98.975 c-53.598,62.853-118.24,118.609-189.451,165.798c-7.495,4.967-18.233,3.746-23.986-2.726 c-5.648-6.355-4.386-15.411,2.758-20.439l0.051-0.035c16.944-11.901,33.71-23.954,49.795-36.611 c8.162-6.219,15.987-12.737,23.95-19.126c7.673-6.641,15.649-13.027,23.077-19.866c30.238-26.913,58.251-55.628,83.667-85.989 c51.121-60.44,92.046-127.79,123.051-197.61c15.05-35.073,27.082-71.041,35.866-107.685 c8.753-36.653,14.258-73.944,17.302-111.534c6.098-75.223,3.343-151.416,0.985-227.833 c-2.244-76.438-3.89-153.263-1.873-230.026c0.889-38.379,2.576-76.74,5.057-115.056c1.113-19.163,2.656-38.304,4.158-57.445 c1.715-19.128,3.553-38.246,5.57-57.346c8.234-76.393,19.163-152.531,32.862-228.265 c14.12-75.677,30.561-151.005,50.334-225.658c0.566-2.134,3.026-3.468,5.497-2.98 C3103.607,707.768,3105.132,709.797,3104.699,711.867z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2876.168,1926.662c12.003,18.652,39.154,18.983,51.847,0.795 c70.041-100.36,242.411-402.023,126.035-808.168c-98.275-342.971-118.971-538.283-122.222-627.598 c-0.688-18.887-25.086-25.918-35.75-10.314C2778.432,653.526,2441.231,1250.806,2876.168,1926.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2905.487,1920.152c0.514,0.194,1.053,0.342,1.616,0.437c4.714,0.803,9.187-2.368,9.99-7.082 c0.91-5.345,89.678-539.999-25.424-1023.05c-1.109-4.648-5.778-7.522-10.433-6.417c-4.653,1.11-7.524,5.779-6.418,10.433 c114.266,479.534,26.105,1010.818,25.201,1016.127C2899.312,1914.752,2901.687,1918.717,2905.487,1920.152z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0439 -0.999 0.999 0.0439 -66.3675 3475.3857)",
    style: {
      fill: "#7D97F4"
    },
    cx: 1782.468,
    cy: 1772.365,
    rx: 1209.58,
    ry: 1305.623
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.1,
      fill: "#91B3FA"
    },
    cx: 1711.805,
    cy: 1685.096,
    rx: 1024.509,
    ry: 967.834
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.68
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2116.011,1778.208c-0.314,213.337-14.944,427.108-52.54,637.424 c-9.518,52.535-20.552,104.82-33.699,156.607c-13.187,51.767-28.412,103.085-47.054,153.259 c-18.797,50.043-40.614,99.367-70.199,144.446c-14.908,22.375-31.818,43.814-52.686,61.451 c-10.431,8.762-21.886,16.533-34.487,22.226c-12.574,5.656-26.317,9.237-40.264,9.485c-13.929,0.407-27.88-2.319-40.702-7.483 c-12.872-5.114-24.606-12.535-35.288-21.007c-21.367-17.087-38.649-38.291-53.824-60.49 c-30.109-44.758-52.223-93.982-71.217-143.947c-18.877-50.088-34.252-101.365-47.554-153.101 c-13.279-51.753-24.423-104.013-34.02-156.532c-19.153-105.06-32.215-211.13-41.03-317.492 c-8.751-106.379-13.138-213.098-13.677-319.833c-0.262-53.361,1.194-106.712,3.091-160.031 c1.998-53.318,4.935-106.601,8.86-159.813c7.893-106.409,19.68-212.582,37.205-317.882 c8.793-52.638,19.046-105.053,31.379-157.005c12.364-51.934,26.733-103.456,44.556-153.86 c8.958-25.179,18.753-50.089,29.922-74.414c11.153-24.319,23.635-48.108,38.304-70.598 c14.703-22.392,31.604-43.765,52.651-60.875c10.521-8.48,22.114-15.858,34.814-20.857c12.649-5.063,26.374-7.627,40.027-7.108 c13.661,0.389,27.128,3.795,39.553,9.267c12.442,5.499,23.876,12.976,34.372,21.452c20.994,17.06,38.37,37.919,53.785,59.823 c30.647,44.113,53.751,92.762,73.765,142.261c19.867,49.635,36.271,100.556,50.559,152.003 c14.237,51.471,26.293,103.516,36.726,155.866C2098.624,1351.036,2115.395,1564.834,2116.011,1778.208z M2100.22,1778.208 c0.196-106.3-3.845-212.627-12.679-318.559c-8.709-105.927-21.904-211.55-41.561-316.003 c-9.816-52.219-21.248-104.143-34.85-155.492c-13.651-51.322-29.407-102.122-48.591-151.607 c-19.321-49.345-41.727-97.824-71.459-141.623c-14.945-21.746-31.804-42.398-52.034-59.201 c-10.111-8.351-21.089-15.689-32.968-21.093c-11.867-5.339-24.649-8.839-37.648-9.18c-12.991-0.412-25.965,2.201-37.982,7.147 c-12.059,4.896-23.13,12.1-33.223,20.418c-20.193,16.776-36.553,37.878-50.773,60.071 c-14.193,22.288-26.276,45.927-37.052,70.122c-10.794,24.2-20.239,49.011-28.859,74.099 c-17.145,50.228-30.875,101.612-42.611,153.414c-11.705,51.822-21.343,104.114-29.525,156.626 c-16.306,105.049-26.896,210.958-33.6,317.063c-6.771,106.119-9.11,212.478-8.918,318.79 c-0.281,106.295,3.27,212.62,11.17,318.627c7.963,105.989,20.16,211.712,38.413,316.397 c9.147,52.331,19.832,104.395,32.632,155.922c12.821,51.509,27.699,102.534,46.012,152.279 c18.412,49.612,39.942,98.422,69.04,142.385c14.644,21.798,31.306,42.472,51.5,58.863c10.091,8.132,21.073,15.169,32.944,19.987 c11.835,4.831,24.534,7.515,37.257,7.086c12.719-0.328,25.252-3.687,36.886-9.024c11.652-5.374,22.4-12.764,32.271-21.192 c19.756-16.956,36.063-37.89,50.449-59.875c28.588-44.31,49.808-93.23,68.013-142.925 c18.066-49.836,32.779-100.905,45.471-152.445c12.656-51.562,23.213-103.65,32.269-155.995 c18.13-104.704,30.176-210.439,38.185-316.428C2096.515,1990.865,2100.262,1884.529,2100.22,1778.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2654.193,1778.208c-0.738,137.383-18.395,274.826-55.172,407.311 c-37.419,132.18-93.827,259.342-170.408,373.507c-38.295,57.021-81.68,110.693-130.157,159.389 c-48.456,48.682-102.047,92.369-160.219,128.982c-58.225,36.472-121.113,65.668-186.943,85.476 c-65.792,19.855-134.474,30.213-203.219,30.282c-68.744-0.006-137.445-10.302-203.272-30.102 c-65.865-19.753-128.804-48.903-187.089-85.338c-58.232-36.575-111.902-80.224-160.437-128.886 c-48.558-48.675-92.028-102.335-130.41-159.356c-76.736-114.181-133.262-241.397-170.857-373.643 c-18.505-66.244-32.256-133.797-41.366-201.951c-9.062-68.166-13.615-136.906-13.927-205.671 c0.355-68.766,4.951-137.5,14.055-205.655c9.154-68.143,22.957-135.676,41.506-201.894 c37.688-132.192,94.302-259.322,171.088-373.385c38.398-56.968,81.875-110.57,130.426-159.18 c48.536-48.587,102.167-92.196,160.389-128.656c58.267-36.341,121.191-65.274,186.942-85.021 c65.708-19.828,134.3-30.17,202.953-30.237c68.654,0.125,137.227,10.524,202.904,30.403 c65.717,19.799,128.587,48.79,186.794,85.17c58.159,36.501,111.714,80.145,160.169,128.754 c48.472,48.631,91.862,102.244,130.174,159.212c76.63,114.047,133.129,241.121,170.639,373.249 C2635.611,1503.405,2653.362,1640.824,2654.193,1778.208z M2636.091,1778.208c-0.199-135.824-17.118-271.793-52.955-402.905 c-36.036-130.91-90.296-257.292-164.995-370.948c-37.329-56.769-79.726-110.279-127.213-158.92 c-47.505-48.565-99.976-92.504-157.363-129.023c-57.456-36.315-119.502-65.546-184.56-85.317 c-65.026-19.786-132.917-30.186-200.932-30.412c-68.015,0.284-135.889,10.742-200.882,30.577 c-65.025,19.824-127.017,49.112-184.412,85.466c-57.323,36.561-109.717,80.536-157.143,129.121 c-47.405,48.663-89.717,102.183-126.96,158.953c-74.544,113.642-128.687,239.967-164.546,370.812 c-17.864,65.497-30.799,132.283-39.563,199.565c-8.785,67.291-13.12,135.149-13.272,203.029 c0.194,67.879,4.572,135.732,13.399,203.011c8.808,67.271,21.795,134.037,39.703,199.507 c35.951,130.792,90.184,257.032,164.778,370.555c37.257,56.718,79.575,110.179,126.976,158.776 c47.425,48.511,99.781,92.446,157.094,128.891c57.378,36.26,119.354,65.332,184.265,85.149 c64.875,19.863,132.638,30.368,200.562,30.712c67.926-0.282,135.707-10.724,200.617-30.532 c64.946-19.762,126.973-48.788,184.41-85.011c57.374-36.409,109.808-80.304,157.313-128.795 c47.48-48.576,89.884-102.026,127.228-158.743c74.749-113.539,129.099-239.834,165.225-370.691 C2618.787,2049.976,2635.8,1914.031,2636.091,1778.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M690.705,1311.701c-0.657-0.006-1.186-0.543-1.181-1.2c0.005-0.65,0.533-1.175,1.181-1.181 l272.119-2.199l272.119-1.246l544.238-1.005l544.238,1.106l272.119,1.361l272.119,2.373c0.441,0.004,0.796,0.365,0.792,0.806 c-0.003,0.436-0.357,0.788-0.792,0.792l-272.119,2.373l-272.119,1.36l-544.238,1.107l-544.238-1.005l-272.119-1.246 L690.705,1311.701z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1005.224,854.716c0.01-0.644,0.532-1.161,1.172-1.172c64.398-1.02,128.798-1.458,193.196-2.198 l193.197-1.246c64.4-0.531,128.798-0.474,193.197-0.638l193.196-0.368l386.392,1.106l193.197,1.36 c64.399,0.808,128.798,1.28,193.197,2.373c0.441,0.008,0.792,0.371,0.785,0.813c-0.007,0.431-0.357,0.778-0.785,0.785 c-64.4,1.094-128.798,1.566-193.197,2.373l-193.197,1.36l-386.392,1.106l-193.196-0.368 c-64.4-0.164-128.798-0.106-193.197-0.637l-193.197-1.246c-64.398-0.74-128.798-1.178-193.196-2.198 C1005.739,855.915,1005.214,855.373,1005.224,854.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M596.141,1767.477c-0.657-0.005-1.186-0.542-1.182-1.199c0.005-0.651,0.532-1.176,1.182-1.181 l295.76-2.191l295.761-1.253l591.52-1.005l591.52,1.107l295.76,1.362l295.76,2.372c0.442,0.004,0.796,0.364,0.793,0.805 c-0.004,0.437-0.358,0.789-0.793,0.793l-295.76,2.372l-295.76,1.362l-591.52,1.106l-591.52-1.005l-295.761-1.253 L596.141,1767.477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M690.705,2220.872l272.119-2.198l272.119-1.246l544.238-1.006l544.238,1.107l272.119,1.36 l272.119,2.373c0.441,0.004,0.796,0.365,0.792,0.806c-0.003,0.436-0.357,0.788-0.792,0.792l-272.119,2.374l-272.119,1.361 l-544.238,1.106l-544.238-1.005l-272.119-1.246l-272.119-2.198c-0.657-0.005-1.186-0.542-1.181-1.199 C689.53,2221.403,690.057,2220.878,690.705,2220.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2595.076,2677.84c0,2.304-1.866,4.172-4.172,4.172h-1545.57c-2.306,0-4.172-1.868-4.172-4.172 c0-2.304,1.866-4.172,4.172-4.172h1545.57C2593.21,2673.668,2595.076,2675.536,2595.076,2677.84z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114751834015300344390000002691691766711262615_",
    gradientUnits: "userSpaceOnUse",
    x1: 1409.4346,
    y1: 2116.8335,
    x2: 3113.3164,
    y2: 2116.8335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114751834015300344390000002691691766711262615_)"
    },
    d: "M2923.761,1032.682l-1315.325,22.117 c-72.566,1.22-131.445,59.093-133.916,131.626l-65.026,1908.609c-1.933,56.759,43.514,103.845,100.306,103.922l1507.989,2.052 c53.365,0.072,96.411-43.643,95.513-97l-32.27-1919.256C3079.595,1099.33,3009.183,1031.247,2923.761,1032.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2796.967,3172.987l0.016,0l168.647-5.017c56.77-1.689,102.179-49.261,101.225-106.047 l-4.282-254.684c-0.041-2.372-1.996-4.263-4.37-4.222c-2.413,0.171-4.267,1.997-4.223,4.369l4.282,254.682 c0.876,52.108-40.795,95.764-92.888,97.313l-168.646,5.018c-2.374,0.069-4.236,2.051-4.167,4.422 C2792.63,3171.185,2794.601,3173.048,2796.967,3172.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M3057.058,2732.717c2.354-0.06,4.226-2.008,4.186-4.366l-0.691-41.244 c-0.041-2.372-1.995-4.266-4.369-4.225c-0.013,0-0.025,0.001-0.025,0.001c-2.366,0.061-4.238,2.008-4.198,4.366l0.692,41.244 c0.04,2.373,1.995,4.266,4.369,4.225C3057.021,2732.718,3057.046,2732.717,3057.058,2732.717z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2919.457,1017.292c-179.211,27.378-795.609,113.1-1306.946,82.484 c-23.319-1.397-43.233,16.589-44.081,39.935l-69.596,1917.187c-0.955,26.288,19.479,48.41,45.76,49.522 c214.995,9.099,1100.358,43.362,1415.305,5.011c19.167-2.334,33.472-18.745,33.26-38.055l-21.993-2012.131 C2970.868,1033.913,2946.476,1013.164,2919.457,1017.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2901.052,1067.303c-172.461,26.348-765.649,108.841-1257.731,79.378 c-22.441-1.344-41.606,15.964-42.422,38.432l-66.974,1844.995c-0.919,25.297,18.745,46.586,44.037,47.656 c206.898,8.757,1058.924,41.729,1362.009,4.823c18.447-2.247,32.213-18.041,32.01-36.622l-21.166-1936.362 C2950.529,1083.298,2927.056,1063.331,2901.052,1067.303z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1660.088,1308.403c-7.063,0.119-12.559-5.557-12.211-12.613l0.044-0.886 c0.347-7.056,6.409-12.972,13.472-13.146l1116.352-27.574c7.062-0.174,9.317,4.264,5.01,9.864l-12.023,15.631 c-4.307,5.6-13.61,10.278-20.674,10.397L1660.088,1308.403z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2778.982,1327.858c7.062-0.174,9.317,4.264,5.01,9.864l-12.023,15.632 c-4.307,5.6-13.61,10.278-20.673,10.397l-1089.969,18.326c-7.063,0.119-12.559-5.557-12.212-12.613l0.044-0.888 c0.347-7.056,6.409-12.972,13.472-13.146L2778.982,1327.858z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2559.993,1965.97c-0.573-57.543-0.412-111.549,7.759-139.992 c4.949-17.225,22.024-28.928,41.648-28.624c0.201,0.003,0.401,0.012,0.605,0.016c27.43,0.768,74.065,5.476,115.213,9.627 c18.899,1.905,36.074,3.641,48.549,4.684l0,0c9.023,0.761,17.305,5.007,22.719,11.657c4.849,5.951,7.03,13.288,6.142,20.665 l-14.95,124.006c-2.317,19.238-20.154,33.649-41.49,33.525l-148.054-0.884c-0.135-0.001-0.271-0.003-0.406-0.007 C2577.071,2000.323,2560.183,1984.844,2559.993,1965.97z M2772.753,1823.723c-12.525-1.056-29.771-2.794-48.746-4.712 c-38.918-3.92-87.351-8.81-114.343-9.566c-13.87-0.716-26.877,7.964-30.3,19.864c-7.723,26.886-7.859,79.93-7.294,136.542 c0.126,12.355,11.69,22.493,25.844,22.713c0.097,0.001,0.198,0.003,0.292,0.005l148.054,0.882 c15.193,0.089,27.843-9.75,29.424-22.892l14.951-124.006c0.494-4.086-0.755-8.206-3.513-11.587 C2783.767,1826.844,2778.531,1824.208,2772.753,1823.723L2772.753,1823.723z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M2756.659,1835.936c-31.064-2.609-98.547-10.524-130.597-11.422 c-13.581-0.38-25.622,7.641-28.99,19.369c-6.542,22.779-6.432,68.39-6.014,110.491c0.126,12.609,11.544,22.85,25.681,22.934 l118.315,0.706c14.549,0.087,26.782-9.645,28.336-22.543l11.945-99.093C2776.572,1846.129,2768.175,1836.904,2756.659,1835.936z "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2469.097,1869.737c7.064-0.058,11.283,5.459,9.375,12.261l-13.725,48.937 c-1.908,6.802-9.248,12.277-16.312,12.167l-743.985-11.578c-7.063-0.11-12.626-5.976-12.362-13.035l1.106-29.532 c0.264-7.06,6.26-12.883,13.325-12.941L2469.097,1869.737z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2551.406,1633.566c-0.572-57.544-0.411-111.55,7.759-139.992 c4.95-17.225,22.025-28.928,41.649-28.624c0.201,0.002,0.401,0.011,0.605,0.015c27.429,0.768,74.065,5.476,115.213,9.627 c18.898,1.905,36.074,3.641,48.549,4.685l0,0c9.023,0.76,17.305,5.006,22.719,11.656c4.848,5.951,7.03,13.288,6.142,20.667 l-14.95,124.005c-2.317,19.238-20.153,33.65-41.489,33.524l-148.054-0.884c-0.136-0.001-0.271-0.003-0.407-0.006 C2568.484,1667.919,2551.598,1652.44,2551.406,1633.566z M2764.167,1491.318c-12.526-1.055-29.772-2.793-48.746-4.712 c-38.918-3.92-87.351-8.81-114.343-9.566c-13.871-0.716-26.877,7.964-30.301,19.865c-7.722,26.886-7.858,79.929-7.293,136.541 c0.126,12.356,11.69,22.494,25.844,22.714c0.097,0,0.197,0.003,0.292,0.004l148.054,0.882 c15.192,0.09,27.843-9.75,29.424-22.892l14.95-124.005c0.494-4.086-0.754-8.206-3.512-11.587 C2775.181,1494.44,2769.946,1491.804,2764.167,1491.318L2764.167,1491.318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M2748.073,1503.532c-31.063-2.609-98.547-10.524-130.597-11.422 c-13.58-0.381-25.622,7.641-28.99,19.369c-6.542,22.78-6.432,68.39-6.014,110.49c0.125,12.61,11.545,22.851,25.682,22.935 l118.315,0.706c14.549,0.087,26.781-9.646,28.336-22.543l11.945-99.093C2767.986,1513.725,2759.588,1504.5,2748.073,1503.532z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2460.511,1537.333c7.064-0.058,11.283,5.459,9.375,12.261l-13.725,48.937 c-1.908,6.802-9.248,12.277-16.312,12.167l-743.985-11.578c-7.063-0.11-12.626-5.976-12.362-13.035l1.106-29.532 c0.264-7.059,6.26-12.883,13.325-12.941L2460.511,1537.333z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2555.057,2283.237c-0.575-57.537-0.413-111.549,7.758-139.986 c4.949-17.231,22.024-28.936,41.65-28.63c0.199,0.002,0.401,0.012,0.603,0.014c27.429,0.77,74.065,5.479,115.213,9.628 c18.898,1.906,36.073,3.64,48.549,4.685l0,0c9.024,0.76,17.305,5.006,22.72,11.657c4.846,5.951,7.028,13.287,6.139,20.671 l-14.948,124c-2.316,19.236-20.153,33.647-41.489,33.523l-148.054-0.882c-0.135-0.002-0.271-0.005-0.406-0.007 C2572.134,2317.589,2555.246,2302.113,2555.057,2283.237z M2767.817,2140.991c-12.525-1.057-29.771-2.794-48.745-4.712 c-38.918-3.921-87.353-8.809-114.344-9.565c-13.872-0.565-26.876,7.958-30.301,19.869c-7.722,26.88-7.856,79.924-7.291,136.536 c0.125,12.356,11.69,22.494,25.841,22.713c0.098,0.002,0.197,0.003,0.291,0.004l148.054,0.882 c15.193,0.089,27.843-9.749,29.425-22.89l14.95-124.001c0.494-4.091-0.755-8.211-3.514-11.593 C2778.827,2144.112,2773.59,2141.475,2767.817,2140.991L2767.817,2140.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M2751.722,2153.207c-31.063-2.611-98.548-10.525-130.596-11.423 c-13.581-0.382-25.621,7.641-28.991,19.369c-6.544,22.779-6.433,68.389-6.014,110.49c0.126,12.609,11.545,22.851,25.682,22.935 l118.315,0.703c14.55,0.086,26.781-9.643,28.336-22.542l11.944-99.091C2771.634,2163.399,2763.239,2154.174,2751.722,2153.207z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2464.159,2187.008c7.064-0.058,11.283,5.459,9.375,12.261l-13.724,48.936 c-1.908,6.802-9.248,12.277-16.311,12.167l-743.987-11.578c-7.063-0.11-12.626-5.976-12.362-13.035l1.106-29.532 c0.265-7.06,6.261-12.883,13.325-12.941L2464.159,2187.008z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2564.166,2588.105c-0.573-57.539-0.412-111.543,7.758-139.986 c5.004-17.407,22.775-29.007,42.251-28.608c27.44,0.768,76.137,5.679,115.267,9.627c18.878,1.905,36.035,3.636,48.5,4.678l0,0 c9.024,0.766,17.307,5.012,22.721,11.662c4.844,5.951,7.027,13.288,6.139,20.668l-14.949,123.999 c-2.32,19.243-20.157,33.655-41.489,33.523l-148.058-0.876c-0.132-0.001-0.261-0.003-0.392-0.005 C2581.253,2622.463,2564.354,2606.979,2564.166,2588.105z M2776.927,2445.857c-12.516-1.055-29.745-2.792-48.699-4.703 c-38.933-3.927-87.387-8.818-114.391-9.567c-13.875-0.416-26.877,7.958-30.301,19.862c-7.722,26.887-7.857,79.925-7.293,136.537 c0.128,12.439,12.183,22.26,26.135,22.724l148.058,0.875c15.188,0.095,27.839-9.748,29.421-22.891l14.949-124 c0.494-4.085-0.753-8.2-3.51-11.588C2787.939,2448.984,2782.7,2446.344,2776.927,2445.857L2776.927,2445.857z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M2760.833,2458.075c-31.065-2.608-98.547-10.522-130.597-11.42 c-13.581-0.38-25.622,7.638-28.991,19.369c-6.542,22.779-6.433,68.389-6.014,110.49c0.126,12.61,11.546,22.849,25.683,22.933 l118.314,0.705c14.548,0.087,26.781-9.643,28.336-22.542l11.944-99.091C2780.744,2468.268,2772.348,2459.043,2760.833,2458.075z "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2473.269,2491.878c7.064-0.058,11.283,5.459,9.375,12.261l-13.725,48.934 c-1.908,6.802-9.248,12.277-16.312,12.167l-743.986-11.576c-7.063-0.11-12.626-5.976-12.362-13.035l1.106-29.535 c0.264-7.059,6.261-12.883,13.325-12.941L2473.269,2491.878z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2401.648,2805.061c7.064-0.078,11.43,5.463,9.701,12.312l-12.311,48.794 c-1.728,6.85-8.922,12.364-15.985,12.254l-662.505-10.31c-7.064-0.11-12.64-5.976-12.392-13.036l1.037-29.533 c0.248-7.06,6.231-12.9,13.295-12.978L2401.648,2805.061z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2765.326,2825.812c7.058-0.31,12.137,5.174,11.288,12.187l-4.495,37.115 c-0.849,7.013-7.323,12.661-14.387,12.552l-234.964-3.657c-7.064-0.11-12.703-5.978-12.531-13.041l0.514-21.134 c0.171-7.062,6.086-13.094,13.144-13.405L2765.326,2825.812z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017484605143033199320000001859568479610265531_",
    gradientUnits: "userSpaceOnUse",
    x1: 2017.0319,
    y1: 1907.3652,
    x2: 1421.7732,
    y2: 2690.4141,
    gradientTransform: "matrix(0.8398 -0.543 0.543 0.8398 -465.0261 6.1533)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017484605143033199320000001859568479610265531_)"
    },
    d: "M2180.623,972.454l149.016-15.753 l10.239-137.102c2.06-27.588-15.563-52.911-42.224-60.293c-29.226-8.093-70.55-8.052-117.505,25.798 C2088.062,851.494,2180.623,972.454,2180.623,972.454z M2209.797,857.852c-0.346-20.552,16.036-37.492,36.588-37.838 c20.552-0.346,37.492,16.036,37.838,36.588c0.345,20.552-16.035,37.492-36.587,37.838 C2227.084,894.785,2210.144,878.405,2209.797,857.852z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2313.148,903.135c-4.071-0.302-7.124-3.846-6.82-7.917l1.629-21.836 c0.302-4.083,3.857-7.134,7.925-6.822c4.07,0.303,7.123,3.848,6.819,7.918l-1.629,21.836c-0.218,2.945-2.136,5.356-4.716,6.351 C2315.365,903.047,2314.275,903.22,2313.148,903.135z M2316.341,860.348c-4.071-0.304-7.123-3.847-6.82-7.917l1.24-16.58 c1.573-21.071-11.971-40.422-32.206-46.024c-16.135-4.466-32.71-4.871-49.258-1.184c-3.988,0.887-7.936-1.629-8.822-5.613 c-0.892-3.99,1.688-7.885,5.608-8.824c18.941-4.214,37.927-3.749,56.417,1.371c27.015,7.483,45.099,33.288,43.003,61.369 l-1.239,16.578c-0.217,2.948-2.136,5.358-4.716,6.352C2318.559,860.258,2317.469,860.432,2316.341,860.348z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179611397550582180680000002145608824792020370_",
    gradientUnits: "userSpaceOnUse",
    x1: -979.9722,
    y1: 4130.2744,
    x2: -1585.0299,
    y2: 4926.2139,
    gradientTransform: "matrix(-0.9999 0.0168 0.0168 0.9999 915.3275 -3470.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179611397550582180680000002145608824792020370_)"
    },
    d: "M2534.811,1041.742l-1.158-68.826 c-0.398-23.758-20.41-42.455-44.141-41.242l-474.242,24.236c-21.047,1.075-37.822,17.986-38.729,39.039l-2.854,66.197 L2534.811,1041.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2376.905,960.203c2.353-0.06,4.225-2.008,4.185-4.366c-0.04-2.375-1.994-4.265-4.369-4.225 l-20.406,0.343c-2.475,0.068-4.267,1.997-4.223,4.367c0.041,2.374,1.994,4.265,4.369,4.225l20.406-0.343 C2376.879,960.204,2376.892,960.203,2376.905,960.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2511.363,1023.86c2.811-1.084,4.784-3.833,4.729-7.025l-0.467-27.843 c-0.191-11.432-4.822-22.103-13.044-30.053c-8.22-7.948-19.045-12.225-30.48-12.034l-75.024,1.265 c-4.062,0.081-7.335,3.431-7.264,7.52c0.068,4.083,3.434,7.335,7.518,7.269l75.023-1.267 c15.448-0.259,28.231,12.099,28.488,27.55l0.469,27.844c0.069,4.083,3.435,7.334,7.518,7.269 C2509.719,1024.338,2510.573,1024.164,2511.363,1023.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063599558651790638420000008189411349133262510_",
    gradientUnits: "userSpaceOnUse",
    x1: -1056.2219,
    y1: 4178.9648,
    x2: -1473.9984,
    y2: 4946.0874,
    gradientTransform: "matrix(-0.9999 0.0168 0.0168 0.9999 915.3275 -3470.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063599558651790638420000008189411349133262510_)"
    },
    d: "M2683.07,1014.051l-829.779,13.931 c-29.837,0.5-54.984,22.4-59.58,51.886l-0.634,4.068c-5.032,32.295,20.255,61.332,52.936,60.783l851.305-14.315 c19.559-0.328,34.87-16.943,33.603-36.463l-2.473-38.073C2726.903,1032.056,2706.931,1013.653,2683.07,1014.051z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000211406249689221300000003987245348795008405_",
    gradientUnits: "userSpaceOnUse",
    x1: -1687.9474,
    y1: 4453.7988,
    x2: -2352.5535,
    y2: 5588.125,
    gradientTransform: "matrix(-0.9905 -0.1382 -0.1382 0.9905 1393.6246 -3354.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000211406249689221300000003987245348795008405_)"
    },
    d: "M2753.971,1877.815L2753.971,1877.815 c-8.787-6.951-21.572-5.319-28.329,3.619l-31.788,42.033c-3.182,4.208-9.801,2.99-11.276-2.075l-43.476-149.209 c-2.17-7.443-12.93-6.531-13.886,1.163c-5.35,43.039-5.345,126.267,53.744,204.177c0,0,39.868-9.423,79.654-72.048 C2764.36,1896.427,2762.376,1884.464,2753.971,1877.815z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085971365013424784350000000163202246542761892_",
    gradientUnits: "userSpaceOnUse",
    x1: -1627.5464,
    y1: 4105.0806,
    x2: -2292.1523,
    y2: 5239.4067,
    gradientTransform: "matrix(-0.9905 -0.1382 -0.1382 0.9905 1393.6246 -3354.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085971365013424784350000000163202246542761892_)"
    },
    d: "M2742.337,1524.063L2742.337,1524.063 c-8.787-6.951-21.572-5.319-28.329,3.619l-31.788,42.033c-3.182,4.208-9.801,2.99-11.276-2.075l-43.477-149.209 c-2.17-7.443-12.929-6.531-13.886,1.163c-5.35,43.039-5.345,126.267,53.744,204.177c0,0,39.867-9.424,79.654-72.048 C2752.726,1542.674,2750.742,1530.711,2742.337,1524.063z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045583833670028891010000014191814838662605222_",
    gradientUnits: "userSpaceOnUse",
    x1: -1713.3531,
    y1: 4758.8931,
    x2: -2377.9592,
    y2: 5893.2192,
    gradientTransform: "matrix(-0.9905 -0.1382 -0.1382 0.9905 1393.6246 -3354.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000045583833670028891010000014191814838662605222_)"
    },
    d: "M2736.971,2183.522L2736.971,2183.522 c-8.787-6.951-21.572-5.319-28.329,3.619l-31.788,42.033c-3.182,4.208-9.801,2.99-11.276-2.075l-43.477-149.209 c-2.17-7.443-12.929-6.531-13.886,1.163c-5.35,43.039-5.345,126.267,53.744,204.176c0,0,39.867-9.423,79.654-72.048 C2747.361,2202.134,2745.377,2190.171,2736.971,2183.522z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103225024198972502160000010704906570075784639_",
    gradientUnits: "userSpaceOnUse",
    x1: -1766.5645,
    y1: 5045.1338,
    x2: -2431.1704,
    y2: 6179.4595,
    gradientTransform: "matrix(-0.9905 -0.1382 -0.1382 0.9905 1393.6246 -3354.3196)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103225024198972502160000010704906570075784639_)"
    },
    d: "M2750.119,2474.397L2750.119,2474.397 c-8.787-6.951-21.572-5.319-28.329,3.619l-31.788,42.033c-3.182,4.208-9.801,2.99-11.276-2.075l-43.476-149.209 c-2.17-7.443-12.93-6.531-13.886,1.163c-5.35,43.039-5.345,126.267,53.744,204.177c0,0,39.868-9.424,79.654-72.048 C2760.508,2493.009,2758.524,2481.046,2750.119,2474.397z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091708176363750314270000008459746287656668602_",
    gradientUnits: "userSpaceOnUse",
    x1: 3242.5085,
    y1: 2115.6299,
    x2: 2677.1538,
    y2: 2398.3079
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091708176363750314270000008459746287656668602_)"
    },
    d: "M2204.341,3220.799 c63.034,1.198,114.778-49.572,114.778-112.617V2607.01c0-65.847-52.917-119.425-118.76-120.142 c-197.61-2.152-605.171-2.259-938.644,25.843c-45.505,3.834-80.902,41.132-82.551,86.769l-31.167,484.532 c-2.316,64.09,48.354,117.633,112.474,118.851L2204.341,3220.799z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2204.665,2661.234c0.84,42.644-0.426,110.306-1.463,154.021 c-0.539,22.743-20.506,40.075-43.101,37.427l-162.627-19.06c-21.665-2.54-36.928-22.507-33.695-44.079l19.962-133.166 c2.834-18.905,19.074-32.892,38.19-32.892h144.124C2187.056,2623.486,2204.251,2640.237,2204.665,2661.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M1779.668,2913.602l-135.66,14.635c-18.983,2.05-35.18-13.606-33.782-32.648 l29.657-403.548c56.869-1.803,112.961-3.118,167.087-4.042v395.194C1806.971,2898.815,1795.2,2911.926,1779.668,2913.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1724.066,2843.659c-0.418,7.259-6.432,12.856-13.61,12.856c-0.268,0-0.534-0.009-0.8-0.027 c-7.525-0.435-13.272-6.885-12.828-14.41l20.455-352.202c9.173-0.227,18.271-0.431,27.367-0.633L1724.066,2843.659z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124137457252870823500000003141124851183782035_",
    gradientUnits: "userSpaceOnUse",
    x1: -514.4335,
    y1: 2648.4282,
    x2: -805.5443,
    y2: 3071.448,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124137457252870823500000003141124851183782035_)"
    },
    d: "M2129.456,2788.357 c2.381,0,4.388-1.847,4.54-4.265l7.036-110.933c0.16-2.505-1.741-4.665-4.255-4.824c-2.639-0.205-4.664,1.75-4.824,4.256 l-7.036,110.934c-0.16,2.505,1.741,4.663,4.255,4.823C2129.269,2788.357,2129.367,2788.357,2129.456,2788.357z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011012722344582356700000010686560923900554428_",
    gradientUnits: "userSpaceOnUse",
    x1: -503.966,
    y1: 2655.6321,
    x2: -795.0768,
    y2: 3078.6519,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011012722344582356700000010686560923900554428_)"
    },
    d: "M2114.975,2788.357 c2.443,0,4.469-1.937,4.549-4.398l3.686-113.056c0.08-2.515-1.892-4.62-4.397-4.701c-2.897-0.142-4.611,1.893-4.7,4.398 l-3.687,113.057c-0.08,2.514,1.893,4.62,4.398,4.7C2114.824,2788.357,2114.93,2788.357,2114.975,2788.357z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149347714009067592830000005760666600289332098_",
    gradientUnits: "userSpaceOnUse",
    x1: -491.3362,
    y1: 2664.3235,
    x2: -782.4471,
    y2: 3087.3433,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149347714009067592830000005760666600289332098_)"
    },
    d: "M2095.341,2788.347 c-2.514-0.116-4.45-2.247-4.326-4.752c1.803-37.979,5.241-110.419,5.294-112.888c0.018-2.488,2.053-4.505,4.549-4.505 c2.514,0,4.549,2.035,4.549,4.549c0,1.874-4.424,94.685-5.313,113.27c-0.115,2.443-2.124,4.336-4.54,4.336 C2095.483,2788.357,2095.412,2788.357,2095.341,2788.347z M2096.22,2670.751h0.089H2096.22z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000081626750657643608240000006637469226679979958_",
    gradientUnits: "userSpaceOnUse",
    x1: -469.4906,
    y1: 2679.3572,
    x2: -760.6006,
    y2: 3102.376,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000081626750657643608240000006637469226679979958_)"
    },
    d: "M2065.233,2792.905 c4.879,0,8.911-3.865,9.08-8.777c3.847-109.539,3.171-112.01,2.727-113.644c-1.315-4.859-6.361-7.71-11.167-6.387 c-4.451,1.217-7.232,5.535-6.627,9.985c0.293,6.583-1.741,70.317-3.109,109.406c-0.178,5.019,3.749,9.24,8.768,9.408 C2065.012,2792.905,2065.127,2792.905,2065.233,2792.905z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099629493563152418400000013206372553852569522_",
    gradientUnits: "userSpaceOnUse",
    x1: -455.0859,
    y1: 2689.27,
    x2: -746.1966,
    y2: 3112.2896,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099629493563152418400000013206372553852569522_)"
    },
    d: "M2045.52,2788.357 c2.515,0,4.549-2.034,4.549-4.549v-110.934c0-2.515-2.034-4.549-4.549-4.549c-2.514,0-4.548,2.034-4.548,4.549v110.934 C2040.972,2786.323,2043.005,2788.357,2045.52,2788.357z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042733162216184846030000006141318294226933935_",
    gradientUnits: "userSpaceOnUse",
    x1: -446.1435,
    y1: 2695.4246,
    x2: -737.2522,
    y2: 3118.4412,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042733162216184846030000006141318294226933935_)"
    },
    d: "M2029.6,2788.357 c2.469,0,4.495-1.973,4.548-4.443c0.871-38.546,2.905-101.508,4.727-109.077c0.799-1.43,0.79-3.243-0.168-4.717 c-1.377-2.114-4.194-2.683-6.299-1.306c-2.479,1.625-4.833,3.163-7.356,114.887c-0.053,2.514,1.936,4.593,4.442,4.655H2029.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126304727807220453010000003969488002017658518_",
    gradientUnits: "userSpaceOnUse",
    x1: -529.4122,
    y1: 2638.1213,
    x2: -820.5215,
    y2: 3061.1389,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126304727807220453010000003969488002017658518_)"
    },
    d: "M2153.931,2798.458 c4.806,0,8.823-3.767,9.08-8.626l6.067-116.487c0.258-5.019-3.598-9.292-8.617-9.559c-4.761-0.337-9.292,3.599-9.559,8.618 l-6.067,116.487c-0.258,5.02,3.597,9.292,8.616,9.559C2153.611,2798.458,2153.771,2798.458,2153.931,2798.458z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176725373529465215590000013285088982643652002_",
    gradientUnits: "userSpaceOnUse",
    x1: 2042.5382,
    y1: 1855.5613,
    x2: 1663.9545,
    y2: 2542.061
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176725373529465215590000013285088982643652002_)"
    },
    d: "M2231.839,2413.644v-351.961 c0-46.242-37.162-83.869-83.402-84.372c-138.777-1.511-424.997-1.587-659.187,18.148c-31.957,2.693-56.815,28.886-57.973,60.935 l-21.888,340.275c-1.627,45.009,33.958,82.611,78.987,83.466l662.858,12.596 C2195.501,2493.574,2231.839,2457.919,2231.839,2413.644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2151.461,2099.765c0.59,29.948-0.299,77.465-1.027,108.166 c-0.379,15.971-14.401,28.143-30.27,26.283l-114.208-13.386c-15.214-1.783-25.933-15.805-23.663-30.955l14.018-93.519 c1.991-13.276,13.395-23.098,26.82-23.098h101.215C2139.094,2073.255,2151.17,2085.019,2151.461,2099.765z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M1852.996,2276.996l-95.271,10.277c-13.33,1.439-24.706-9.555-23.724-22.928 l20.828-283.401c39.937-1.266,79.33-2.19,117.341-2.839v277.535C1872.17,2266.612,1863.903,2275.819,1852.996,2276.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1813.948,2227.877c-0.294,5.098-4.518,9.028-9.558,9.028c-0.188,0-0.375-0.007-0.562-0.019 c-5.285-0.305-9.321-4.835-9.009-10.119l14.366-247.343c6.441-0.159,12.83-0.303,19.219-0.445L1813.948,2227.877z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013194414876386450680000017897469446573848194_",
    gradientUnits: "userSpaceOnUse",
    x1: -498.9465,
    y1: 2090.7712,
    x2: -703.386,
    y2: 2387.8469,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013194414876386450680000017897469446573848194_)"
    },
    d: "M2098.643,2189.039 c1.672,0,3.082-1.297,3.189-2.995l4.941-77.905c0.113-1.76-1.223-3.276-2.988-3.388c-1.854-0.144-3.275,1.228-3.388,2.988 l-4.942,77.907c-0.112,1.759,1.223,3.275,2.989,3.387C2098.512,2189.039,2098.581,2189.039,2098.643,2189.039z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078018357807771607610000003812604868618900892_",
    gradientUnits: "userSpaceOnUse",
    x1: -491.5956,
    y1: 2095.8301,
    x2: -696.0351,
    y2: 2392.9058,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078018357807771607610000003812604868618900892_)"
    },
    d: "M2088.474,2189.039 c1.715,0,3.138-1.36,3.194-3.088l2.589-79.397c0.056-1.767-1.329-3.244-3.088-3.301c-2.035-0.1-3.238,1.329-3.301,3.089 l-2.59,79.397c-0.056,1.765,1.329,3.244,3.089,3.301C2088.368,2189.039,2088.442,2189.039,2088.474,2189.039z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097484066668635199840000007687200446365489052_",
    gradientUnits: "userSpaceOnUse",
    x1: -482.726,
    y1: 2101.9338,
    x2: -687.166,
    y2: 2399.01,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000097484066668635199840000007687200446365489052_)"
    },
    d: "M2074.685,2189.033 c-1.765-0.082-3.125-1.579-3.038-3.338c1.266-26.672,3.681-77.544,3.718-79.279c0.013-1.747,1.442-3.164,3.195-3.164 c1.766,0,3.195,1.429,3.195,3.194c0,1.317-3.107,66.496-3.731,79.548c-0.081,1.716-1.491,3.044-3.188,3.044 C2074.786,2189.039,2074.735,2189.039,2074.685,2189.033z M2075.302,2106.447h0.062H2075.302z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175314364869288532650000003785395263559201673_",
    gradientUnits: "userSpaceOnUse",
    x1: -467.3842,
    y1: 2112.4917,
    x2: -671.8237,
    y2: 2409.5674,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175314364869288532650000003785395263559201673_)"
    },
    d: "M2053.542,2192.233 c3.426,0,6.258-2.714,6.376-6.164c2.701-76.926,2.227-78.661,1.915-79.809c-0.924-3.413-4.467-5.415-7.842-4.486 c-3.126,0.854-5.079,3.887-4.654,7.012c0.205,4.623-1.223,49.382-2.184,76.833c-0.125,3.525,2.633,6.489,6.158,6.607 C2053.386,2192.233,2053.467,2192.233,2053.542,2192.233z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170965390461538429490000002285262486294613395_",
    gradientUnits: "userSpaceOnUse",
    x1: -457.2683,
    y1: 2119.4531,
    x2: -661.7081,
    y2: 2416.5291,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170965390461538429490000002285262486294613395_)"
    },
    d: "M2039.697,2189.039 c1.766,0,3.195-1.428,3.195-3.195v-77.906c0-1.766-1.429-3.195-3.195-3.195c-1.765,0-3.193,1.429-3.193,3.195v77.906 C2036.503,2187.611,2037.932,2189.039,2039.697,2189.039z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039819315408128602150000010476537080173120679_",
    gradientUnits: "userSpaceOnUse",
    x1: -450.9882,
    y1: 2123.7754,
    x2: -655.4269,
    y2: 2420.8499,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039819315408128602150000010476537080173120679_)"
    },
    d: "M2028.517,2189.039 c1.734,0,3.157-1.385,3.194-3.119c0.612-27.071,2.041-71.287,3.319-76.602c0.562-1.004,0.556-2.278-0.118-3.313 c-0.967-1.484-2.945-1.884-4.423-0.917c-1.741,1.141-3.394,2.221-5.166,80.682c-0.037,1.766,1.36,3.226,3.12,3.269H2028.517z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003787201062204054060000013970807860293489331_",
    gradientUnits: "userSpaceOnUse",
    x1: -509.4657,
    y1: 2083.5325,
    x2: -713.9053,
    y2: 2380.6084,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003787201062204054060000013970807860293489331_)"
    },
    d: "M2115.832,2196.133 c3.375,0,6.196-2.645,6.376-6.058l4.261-81.806c0.181-3.525-2.527-6.526-6.052-6.713c-3.344-0.237-6.526,2.528-6.713,6.052 l-4.261,81.806c-0.181,3.525,2.526,6.525,6.052,6.713C2115.607,2196.133,2115.719,2196.133,2115.832,2196.133z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014616368131938322650000007741286959490880133_",
    gradientUnits: "userSpaceOnUse",
    x1: 1716.8402,
    y1: 2652.6011,
    x2: 1095.9613,
    y2: 3248.2417
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014616368131938322650000007741286959490880133_)"
    },
    d: "M1735.58,3140.332v-351.961 c0-46.242-32.117-83.868-72.078-84.372c-119.935-1.511-367.293-1.587-569.687,18.148c-27.618,2.693-49.101,28.886-50.102,60.935 l-18.916,340.275c-1.406,45.009,29.347,82.611,68.263,83.466l572.858,12.596 C1704.176,3220.261,1735.58,3184.606,1735.58,3140.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1666.115,2826.452c0.51,29.948-0.258,77.465-0.888,108.166 c-0.328,15.971-12.446,28.143-26.16,26.283l-98.702-13.386c-13.148-1.783-22.412-15.805-20.45-30.955l12.115-93.52 c1.72-13.276,11.577-23.098,23.179-23.098h87.473C1655.428,2799.942,1665.864,2811.706,1666.115,2826.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.37,
      fill: "#FFFFFF"
    },
    d: "M1408.174,3003.683l-82.336,10.277c-11.521,1.44-21.351-9.555-20.502-22.928 l18-283.401c34.515-1.267,68.559-2.19,101.409-2.839v277.535C1424.745,2993.299,1417.601,3002.507,1408.174,3003.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1374.428,2954.564c-0.254,5.098-3.904,9.028-8.26,9.028c-0.162,0-0.324-0.007-0.486-0.02 c-4.567-0.306-8.055-4.835-7.786-10.119l12.415-247.343c5.567-0.159,11.088-0.303,16.609-0.445L1374.428,2954.564z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050660014351135297160000006991297709702240641_",
    gradientUnits: "userSpaceOnUse",
    x1: -20.3731,
    y1: 2817.3655,
    x2: -225.1543,
    y2: 3114.9375,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050660014351135297160000006991297709702240641_)"
    },
    d: "M1620.469,2915.727 c1.445,0,2.663-1.297,2.756-2.995l4.27-77.906c0.097-1.76-1.057-3.276-2.583-3.388c-1.602-0.144-2.83,1.229-2.928,2.988 l-4.271,77.907c-0.097,1.759,1.057,3.275,2.583,3.387C1620.356,2915.727,1620.415,2915.727,1620.469,2915.727z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062905573897914625750000010848206971133006010_",
    gradientUnits: "userSpaceOnUse",
    x1: -14.6645,
    y1: 2822.5723,
    x2: -218.8922,
    y2: 3119.3401,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062905573897914625750000010848206971133006010_)"
    },
    d: "M1611.681,2915.727 c1.482,0,2.712-1.36,2.76-3.088l2.238-79.397c0.048-1.767-1.148-3.244-2.669-3.301c-1.759-0.1-2.799,1.329-2.852,3.089 l-2.238,79.397c-0.049,1.765,1.149,3.244,2.669,3.301C1611.589,2915.727,1611.653,2915.727,1611.681,2915.727z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158709570318774684710000007703553102591506562_",
    gradientUnits: "userSpaceOnUse",
    x1: -7.5222,
    y1: 2828.6072,
    x2: -212.0257,
    y2: 3125.7761,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158709570318774684710000007703553102591506562_)"
    },
    d: "M1599.764,2915.72 c-1.526-0.082-2.701-1.579-2.626-3.338c1.094-26.672,3.181-77.544,3.213-79.279c0.012-1.747,1.246-3.164,2.761-3.164 c1.526,0,2.761,1.429,2.761,3.194c0,1.317-2.685,66.496-3.225,79.548c-0.07,1.716-1.289,3.044-2.755,3.044 C1599.851,2915.727,1599.807,2915.727,1599.764,2915.72z M1600.298,2833.135h0.054H1600.298z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115488210318573377700000001340085167899651004_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.6958,
    y1: 2839.3455,
    x2: -198.7553,
    y2: 3134.9849,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115488210318573377700000001340085167899651004_)"
    },
    d: "M1581.491,2918.921 c2.96,0,5.408-2.714,5.511-6.164c2.335-76.927,1.925-78.662,1.655-79.809c-0.798-3.413-3.86-5.416-6.777-4.486 c-2.702,0.854-4.389,3.887-4.022,7.012c0.177,4.623-1.057,49.382-1.887,76.833c-0.108,3.525,2.275,6.489,5.322,6.607 C1581.357,2918.921,1581.427,2918.921,1581.491,2918.921z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183238837332555682300000006199934773675187903_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.8313,
    y1: 2846.2434,
    x2: -190.84,
    y2: 3142.2029,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183238837332555682300000006199934773675187903_)"
    },
    d: "M1569.526,2915.727 c1.526,0,2.761-1.428,2.761-3.195v-77.906c0-1.766-1.235-3.195-2.761-3.195c-1.526,0-2.76,1.429-2.76,3.195v77.906 C1566.766,2914.298,1568.001,2915.727,1569.526,2915.727z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083089976104027599220000004437036937171948459_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.9209,
    y1: 2850.4568,
    x2: -186.5753,
    y2: 3147.6147,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083089976104027599220000004437036937171948459_)"
    },
    d: "M1559.864,2915.727 c1.499,0,2.729-1.385,2.76-3.119c0.529-27.071,1.764-71.287,2.869-76.602c0.485-1.004,0.48-2.277-0.102-3.313 c-0.836-1.484-2.545-1.884-3.823-0.917c-1.504,1.141-2.933,2.221-4.465,80.682c-0.032,1.766,1.175,3.226,2.696,3.269H1559.864z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149346731332619527620000009132245451994803343_",
    gradientUnits: "userSpaceOnUse",
    x1: -28.7818,
    y1: 2810.3828,
    x2: -232.7043,
    y2: 3106.7073,
    gradientTransform: "matrix(-1 0 0 1 1563.5464 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149346731332619527620000009132245451994803343_)"
    },
    d: "M1635.324,2922.82 c2.917,0,5.355-2.645,5.511-6.058l3.682-81.806c0.156-3.525-2.184-6.526-5.23-6.713c-2.89-0.237-5.64,2.528-5.801,6.052 l-3.683,81.806c-0.157,3.525,2.183,6.525,5.23,6.713C1635.13,2922.82,1635.227,2922.82,1635.324,2922.82z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047047887671225834570000012959123279320928928_",
    gradientUnits: "userSpaceOnUse",
    x1: 797.3528,
    y1: 1035.3499,
    x2: -420.5428,
    y2: 2593.5405,
    gradientTransform: "matrix(1 0 0 1 1074.0826 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047047887671225834570000012959123279320928928_)"
    },
    d: "M1767.859,1636.134l-49.534,26.656 c-59.407,36.169-112.566,55.281-160.405,62.459c-149.371,22.412-246.726-71.836-319.271-129.008 c-95.78-75.482-170.314-38.76-170.314-38.76l102.144,194.944c152.539,143.823,308.938,111.883,407.536,65.277 c62.766-29.667,102.116-65.277,102.116-65.277C1792.343,1685.513,1767.859,1636.134,1767.859,1636.134z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177445323773777538510000015875275670408109467_",
    gradientUnits: "userSpaceOnUse",
    x1: 937.3423,
    y1: 1442.5269,
    x2: 251.3835,
    y2: 2320.1509,
    gradientTransform: "matrix(1 0 0 1 1074.0826 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177445323773777538510000015875275670408109467_)"
    },
    d: "M1913.786,1705.937 c-3.198-10.63-11.057-19.231-21.358-23.373l-100.529-40.427c0,0-1.517-12.893,21.24-21.654 c22.759-8.761,17.438-34.25,17.438-34.25s-31.091,14.183-76.61,36.678c-26.031,12.864-40.636,35.578-48.382,52.676 l25.879,34.033c61.958,18.613,124.653,22.172,187.882,14.789L1913.786,1705.937z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105385483752112480410000008333068322056492454_",
    gradientUnits: "userSpaceOnUse",
    x1: 863.0016,
    y1: 3034.6804,
    x2: 908.0162,
    y2: 3253.6152,
    gradientTransform: "matrix(-1 0 0 1 2064.6489 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105385483752112480410000008333068322056492454_)"
    },
    d: "M1046.381,3126.742 c0,0-7.652,43.321-11.404,86.204c-1.467,16.76,11.454,31.313,28.264,32.012c57.107,2.379,179.264,7.003,223.097,5.048 c6.589-0.293,10.897-7.04,8.459-13.169l0,0c-2.043-5.135-5.984-9.287-11.006-11.595l-201.78-92.738L1046.381,3126.742z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069391522685047068490000014079300630271639966_",
    gradientUnits: "userSpaceOnUse",
    x1: 2991.8396,
    y1: 3126.5635,
    x2: 3057.4722,
    y2: 3126.5635,
    gradientTransform: "matrix(1 0 0 1 -1951.7264 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069391522685047068490000014079300630271639966_)"
    },
    d: "M1040.113,3101.287l6.148,51.818 c0,0,35.346,16.455,59.484-2.074l-14.638-57.746L1040.113,3101.287z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055675424125372897000000011494159928344600966_",
    gradientUnits: "userSpaceOnUse",
    x1: 2690.4026,
    y1: 1382.2039,
    x2: 3017.8706,
    y2: 2805.5532,
    gradientTransform: "matrix(1 0 0 1 -1951.7264 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055675424125372897000000011494159928344600966_)"
    },
    d: "M1030.245,2092.936 c-2.656,14.03,4.765,734.9,75.501,1042.366c1.154,5.018,8.469,14.865,5.945,19.182c-6.138,10.499-51.338,7.552-76.827,8.44 c-7.893,0.275-12.133-8.99-14.36-16.845c-20.22-71.336-117.107-428.757-129.747-770.189c-14.122-381.517,0-12.99,0-12.99 l-6.276-241.707L1030.245,2092.936z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000162348817223344986610000004341896428524886937_",
    gradientUnits: "userSpaceOnUse",
    x1: 1223.8577,
    y1: 3046.0837,
    x2: 1221.8115,
    y2: 3262.9731,
    gradientTransform: "matrix(-1 0 0 1 2064.6489 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000162348817223344986610000004341896428524886937_)"
    },
    d: "M814.268,3149.342 c0,0-12.181,21.871-23.973,79.985c-2.13,10.494,5.202,20.54,15.861,21.588c18.856,1.853,47.886,4.238,71.14,4.078 c10.72-0.073,19.086-9.408,17.794-20.05c-2.575-21.211-10.6-56.013-35.39-83.138L814.268,3149.342z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181803252954441823830000006963703094029236628_",
    gradientUnits: "userSpaceOnUse",
    x1: 2755.2964,
    y1: 3123.1975,
    x2: 2811.9653,
    y2: 3123.1975,
    gradientTransform: "matrix(1 0 0 1 -1951.7264 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181803252954441823830000006963703094029236628_)"
    },
    d: "M803.57,3082.693l14.366,78.362 c0,0,14.203,10.565,42.303,2.906l-6.857-84.313L803.57,3082.693z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102516443038123699690000013401540967206649236_",
    gradientUnits: "userSpaceOnUse",
    x1: 2581.5051,
    y1: 1381.9048,
    x2: 2913.1902,
    y2: 2823.5833,
    gradientTransform: "matrix(1 0 0 1 -1951.7264 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102516443038123699690000013401540967206649236_)"
    },
    d: "M769.039,2121.051 c-57.851,364.434,8.271,928.685,32.014,1033.652c1.454,6.426,6.423,11.349,12.663,12.429c10.599,1.834,28.048,3.33,45.25-1.884 c5.927-1.798,10.091-7.378,10.332-13.815c3.186-84.862-2.548-605.83,51.357-811.72c2.732-10.433,8.837-19.533,17.283-25.8 l88.709-72.298l1.65-155.888L769.039,2121.051z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106858980574596746290000016604213231261172910_",
    gradientUnits: "userSpaceOnUse",
    x1: 722.1152,
    y1: 2622.3594,
    x2: 1469.0103,
    y2: 3335.739,
    gradientTransform: "matrix(1 0 0 1 1074.0826 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106858980574596746290000016604213231261172910_)"
    },
    d: "M1100.516,1536.387 c-152.474-2.519-320.71,40.036-320.71,40.036c-37.464,218.6-22.421,460.865-14.623,540.646 c1.598,16.355-7.15,33.671,9.073,36.292c79.778,12.888,205.177-0.227,244.143-11.547c14.241-4.137,11.82-19.3,14.847-33.817 c26.16-125.476,100.969-402.222,100.969-402.222c36.265,46.65,87.433,111.927,163.079,129.303 c-38.55-44.685,35.392-138.396,27.498-172.006C1256.403,1586.233,1147.544,1537.165,1100.516,1536.387z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089534571435444121180000012864349724579379634_",
    gradientUnits: "userSpaceOnUse",
    x1: 2849.0024,
    y1: 1492.1783,
    x2: 2996.5481,
    y2: 1492.1783,
    gradientTransform: "matrix(1 0 0 1 -1951.7264 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089534571435444121180000012864349724579379634_)"
    },
    d: "M946.073,1412.604l-48.514,140.301 c-0.804,2.325,0.151,4.898,2.303,6.088c13.225,7.312,60.871,28.446,118.288-7.957c5.981-3.793,10.053-9.977,10.961-17 l15.71-121.432H946.073z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178887256602470629840000010369110761946429870_",
    gradientUnits: "userSpaceOnUse",
    x1: -3028.7964,
    y1: 247.4657,
    x2: -3083.9329,
    y2: 65.6129,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 3174.6089 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178887256602470629840000010369110761946429870_)"
    },
    d: "M1051.633,1282.681 c0,0,53.275,100.283,46.446,140.792c-6.829,40.509-72.854,37.601-130.508,4.7l-40.289-108.283L1051.633,1282.681z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062877505586073673240000009795204119073303471_",
    gradientUnits: "userSpaceOnUse",
    x1: -3091.4551,
    y1: -25.2623,
    x2: -3052.686,
    y2: 195.8651,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 3174.6089 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062877505586073673240000009795204119073303471_)"
    },
    d: "M970.119,1374.996 c2.344-1.039,3.208-3.905,1.804-6.05c-4.268-6.52-12.268-19.822-14.822-31.468c0,0-9.577-6.134,24.377-14.261 c18.487-4.425,51.262-8.086,65.665-21.377c16.119-14.875-13.6-42.976-26.096-50.521c-16.491-9.957-36.569-15.847-55.168-10.829 c-8.975,2.421-17.096,7.219-25.091,11.962c-13.616,8.078-27.711,16.604-36.369,29.858c-5.605,8.581-8.542,18.591-11.232,28.481 c-3.865,14.209-7.401,28.762-6.73,43.472c1.787,39.19,47.716,74.301,84.654,78.592c3.021,0.351,5.362-2.632,4.373-5.509 l-15.098-43.887c-0.701-2.038,0.274-4.274,2.245-5.147L970.119,1374.996z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148658103264832059810000007922427395262867643_",
    gradientUnits: "userSpaceOnUse",
    x1: -3085.1592,
    y1: 246.6187,
    x2: -3134.7661,
    y2: 83.0036,
    gradientTransform: "matrix(0.746 -0.6659 0.6659 0.746 3174.6089 -803.1727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148658103264832059810000007922427395262867643_)"
    },
    d: "M976.188,1381.225 c0,0-37.931-26.025-40.703-4.108c-2.772,21.916,34.157,31.744,52.449,23.574L976.188,1381.225z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142172413029772187120000003950415963937715342_",
    gradientUnits: "userSpaceOnUse",
    x1: -4112.8486,
    y1: 8550.627,
    x2: -4393.7446,
    y2: 8793.2197,
    gradientTransform: "matrix(-1 0 0 1 5253.0562 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142172413029772187120000003950415963937715342_)"
    },
    d: "M1071.041,1258.083 c-77.829-147.01-279.549-13.457-185.67,110.385C955.172,1322.057,1034.044,1253.065,1071.041,1258.083z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182499294065491036070000013090339107188025021_",
    gradientUnits: "userSpaceOnUse",
    x1: 832.7336,
    y1: 1225.594,
    x2: 551.8375,
    y2: 1468.1863,
    gradientTransform: "matrix(1 0 0 1 293.427 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182499294065491036070000013090339107188025021_)"
    },
    d: "M949.477,1320.358l139.756-4.322 c3.549-0.11,6.791-2.074,8.512-5.18c12.52-22.608,30.839-37.011,53.746-44.922c2.898-1.001,2.298-5.274-0.761-5.482 l-85.682-5.828c-0.095-0.006-0.191-0.006-0.286,0.001c-42.701,3.283-80.503,28.974-116.563,62.632 C946.995,1318.379,947.832,1320.408,949.477,1320.358z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101816604613874291110000005321539546717721242_",
    gradientUnits: "userSpaceOnUse",
    x1: 655.5065,
    y1: 2692.0986,
    x2: 1402.3994,
    y2: 3405.4758,
    gradientTransform: "matrix(1 0 0 1 1074.0826 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101816604613874291110000005321539546717721242_)"
    },
    d: "M797.074,1798.957 c85.336-95.806,76.692-169.561-19.626-222.655c0,0-159.656,108.479-185.911,246.019c30.166,2.223,85.061,10.068,138.791,37.198 C742.135,1794.576,797.074,1798.957,797.074,1798.957z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179612632088593361780000014509001783821404836_",
    gradientUnits: "userSpaceOnUse",
    x1: 4612.7295,
    y1: 1929.109,
    x2: 5031.0845,
    y2: 1929.109,
    gradientTransform: "matrix(1 0 0 1 -4024.8325 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179612632088593361780000014509001783821404836_)"
    },
    d: "M982.53,1897.547 c0,0-179.252,101.305-239.736,14.803c-12.558-17.961-15.559-35.812-12.467-52.831c-53.73-27.13-108.624-34.976-138.791-37.198 c-7.917,41.463-3.731,85.563,20.634,130.134c105.944,193.803,394.081-10.711,394.081-10.711L982.53,1897.547z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062176908092485494500000000915690124040510624_",
    gradientUnits: "userSpaceOnUse",
    x1: 1753.7307,
    y1: 1310.3853,
    x2: 1450.8617,
    y2: 1577.9192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062176908092485494500000000915690124040510624_)"
    },
    d: "M960.994,2025.709l97.828-341.643 c1.111-3.879,4.419-6.707,8.426-7.174c17.724-2.067,69.085-7.873,128.386-12.89c71.429-6.042,154.38-10.937,203.949-6.773 c7.046,0.592,11.305,8.045,8.171,14.386c-28.187,57.027-144.135,289.001-202.197,364.993c-1.924,2.517-4.898,3.99-8.067,3.96 l-226.981-2.112C963.905,2038.396,959.175,2032.058,960.994,2025.709z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103972813036735768150000017928684612222089344_",
    gradientUnits: "userSpaceOnUse",
    x1: 5256.2969,
    y1: 1679.8682,
    x2: 5207.3047,
    y2: 1895.0061,
    gradientTransform: "matrix(1 0 0 1 -4024.8325 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103972813036735768150000017928684612222089344_)"
    },
    d: "M1205.781,1634.383l70.929-11.818 c3.777-0.629,6.871,2.98,5.67,6.617l-7.021,21.275c-0.611,1.852-2.227,3.193-4.16,3.451l-68.254,9.117 c-3.531,0.472-6.442-2.736-5.631-6.205l4.347-18.576C1202.129,1636.244,1203.755,1634.72,1205.781,1634.383z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010991307481465048420000017620436291177830314_",
    gradientUnits: "userSpaceOnUse",
    x1: 5243.8438,
    y1: 1763.9955,
    x2: 5220.4131,
    y2: 1904.5813,
    gradientTransform: "matrix(1 0 0 1 -4024.8325 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010991307481465048420000017620436291177830314_)"
    },
    d: "M1152.672,1694.43l5.844-30.435 c0.586-3.052,3.106-5.359,6.198-5.673l143.259-14.536c4.823-0.49,8.683,3.93,7.551,8.641l-9.108,37.927 c-0.729,3.034-3.37,5.226-6.486,5.383l-139.994,7.048C1155.379,1703.011,1151.812,1698.911,1152.672,1694.43z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043453377795076780450000015236176241534333872_",
    gradientUnits: "userSpaceOnUse",
    x1: 5000.0234,
    y1: 1885.2449,
    x2: 5130.3589,
    y2: 1885.2449,
    gradientTransform: "matrix(1 0 0 1 -4024.8325 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043453377795076780450000015236176241534333872_)"
    },
    d: "M984.629,1943.168 c0,0-13.628-56.037-8.131-75.917c5.497-19.881,16.148-45.442,51.65-39.761c35.501,5.68,77.379,20.635,77.379,20.635 s-2.116,25.896-29.098,17.541l16.731,12.946c0,0-2.391,20.734-25.181,9.657l15.561,17.17c0,0-9.787,17.028-26.555,6.107 C1040.218,1900.622,1032.18,1949.916,984.629,1943.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027590950122427542380000002446852769232902581_",
    gradientUnits: "userSpaceOnUse",
    x1: -298.0407,
    y1: 1467.6111,
    x2: -329.9608,
    y2: 1955.9889,
    gradientTransform: "matrix(-1 0 0 1 558.3939 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027590950122427542380000002446852769232902581_)"
    },
    d: "M927.822,1729.85 c-11.19,0.9-105.83,3.934-105.83,3.934l3.82,95.277l49.028,27.652l52.983-27.652V1729.85z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031897758413226112820000015208440478180112516_",
    gradientUnits: "userSpaceOnUse",
    x1: -97.1155,
    y1: 1442.1051,
    x2: -307.788,
    y2: 1735.7701,
    gradientTransform: "matrix(-1 0 0 1 558.3939 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000031897758413226112820000015208440478180112516_)"
    },
    points: "935.337,1729.85  822.204,1733.785 817.579,1770.339 876.458,1785.634 939.044,1757.742  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005977325735341912230000009547852613418566044_",
    gradientUnits: "userSpaceOnUse",
    x1: 1420.6385,
    y1: 166.0002,
    x2: 1339.8735,
    y2: 337.6263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005977325735341912230000009547852613418566044_)"
    },
    d: "M1273.886,712.951l-84.261-54.252 c-1.734-1.116-3.829-1.527-5.856-1.147l-111.176,20.812c-2.996,0.56-5.42,2.76-6.269,5.688c-0.849,2.927,0.023,6.083,2.255,8.159 l65.356,60.81L1273.886,712.951z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155838833600408814430000014869189275077296056_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.7678,
    y1: 731.2142,
    x2: 418.1651,
    y2: 1422.7639
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155838833600408814430000014869189275077296056_)"
    },
    d: "M534.39,798.472 c0,0,1035.678-167.247,1075.744-153.662c40.066,13.585,111.351,57.559,132.58,58.005c21.228,0.447,95.26,14.745,75.039,67.415 c-20.221,52.669-879.211,200.269-978.272,164.206c-99.06-36.063-350.341-105.059-350.341-105.059S466.548,792.799,534.39,798.472 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103972706233099592380000015744769849868854432_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.6438,
    y1: 285.0389,
    x2: 671.7833,
    y2: 613.1471
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103972706233099592380000015744769849868854432_)"
    },
    d: "M834.106,753.866l-147.099-85.191 c-9.224-5.342-16.763-13.164-21.761-22.579l-58.175-109.58c-4.609-8.683-14.355-13.352-24.006-11.489 c-30.903,5.965-95.032,19.208-95.465,26.451c-0.571,9.545,26.423,249.907,26.423,249.907L834.106,753.866z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103244467772855211760000013646420778221217424_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.3177,
    y1: 769.1451,
    x2: 728.8693,
    y2: 1206.1289,
    gradientTransform: "matrix(0.9946 0.1035 -0.1035 0.9946 174.8944 148.6298)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103244467772855211760000013646420778221217424_)"
    },
    d: "M543.433,832.992l-13.246,50.349 c-2.235,8.495-0.445,17.21,4.845,24.223c5.29,7.012,13.509,10.877,22.292,11.061l52.473,1.103 c8.287,0.174,16.236-2.91,21.81-9.043l95.577-104.987L543.433,832.992z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020378180993647061440000015734459999719692436_",
    gradientUnits: "userSpaceOnUse",
    x1: 1265.032,
    y1: 1601.626,
    x2: 1219.6013,
    y2: 1263.4224
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020378180993647061440000015734459999719692436_)"
    },
    d: "M1081.247,1011.546 c0,0,31.023,39.676,82.767,40.764s115.731-11.903,128.057-29.961c12.326-18.059,40.637-152.775-64.85-135.52 C1121.734,904.084,997.851,962.804,1081.247,1011.546z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109014263292908934150000013067112967760437673_",
    gradientUnits: "userSpaceOnUse",
    x1: 959.1335,
    y1: 1078.7257,
    x2: 1211.5243,
    y2: 785.9525
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109014263292908934150000013067112967760437673_)"
    },
    d: "M1025.274,870.634l246.102-38.268 l-211.206,260.516c-2.961,3.652-7.315,5.9-12.007,6.198l-147.155,9.361c-6.37,0.405-12.421-2.827-15.625-8.347 c-3.205-5.52-3.013-12.377,0.497-17.708L1025.274,870.634z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065052817120676254650000005889101366382644635_",
    gradientUnits: "userSpaceOnUse",
    x1: 1495.489,
    y1: 854.6943,
    x2: 2101.2285,
    y2: 561.9206
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065052817120676254650000005889101366382644635_)"
    },
    d: "M1278.503,1025.798 c0.628,0.145,1.24,0.183,1.841,0.116c3.289-0.37,6.644-3.706,9.975-9.918c10.708-19.974,18.104-63.042,1.022-96.249l0,0 c-5.063-9.835-14.649-16.271-25.658-17.261c-9.039-0.794-20.647,1.675-24.626,17.957c-6.236,25.524,17.212,85.074,30.846,100.577 C1274.302,1023.75,1276.479,1025.33,1278.503,1025.798z M1268.985,907.533c7.824,1.809,14.662,7.041,18.376,14.263l0,0 c16.163,31.416,8.966,73.521-0.986,92.086c-2.884,5.383-5.32,7.452-6.527,7.585c-0.158,0.022-1.547,0.06-4.586-3.401 c-14.18-16.127-35.367-74.015-29.857-96.563c2.625-10.744,9.13-15.505,19.885-14.56 C1266.541,907.053,1267.777,907.254,1268.985,907.533z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156582428506699727760000010511475180146808988_",
    gradientUnits: "userSpaceOnUse",
    x1: 607.9122,
    y1: 647.0636,
    x2: 1148.0282,
    y2: 394.673
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000156582428506699727760000010511475180146808988_)"
    },
    points: "492.403,608.478  517.878,609.013 538.341,772.135 511.434,777.83  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043428173096315012160000012978138932650687678_",
    gradientUnits: "userSpaceOnUse",
    x1: 1965.2461,
    y1: 342.6308,
    x2: 1618.1855,
    y2: 490.4528,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043428173096315012160000012978138932650687678_)"
    },
    d: "M907.019,812.86 c0.176-8.38,7.112-15.031,15.493-14.854l0.965,0.02c8.38,0.176,15.031,7.112,14.854,15.493l-0.208,9.911 c-0.176,8.38-7.112,15.031-15.493,14.854l-0.965-0.02c-8.38-0.176-15.031-7.112-14.854-15.493L907.019,812.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140737062783631741060000009518647844267200907_",
    gradientUnits: "userSpaceOnUse",
    x1: 1970.9788,
    y1: 360.483,
    x2: 1623.9148,
    y2: 508.3064,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140737062783631741060000009518647844267200907_)"
    },
    d: "M965.264,809.609 c0.176-8.38,7.112-15.031,15.492-14.855l0.965,0.021c8.38,0.176,15.031,7.112,14.855,15.492l-0.209,9.911 c-0.176,8.38-7.112,15.031-15.492,14.855l-0.965-0.021c-8.38-0.176-15.031-7.112-14.855-15.492L965.264,809.609z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019639869677028412810000002984343030811160243_",
    gradientUnits: "userSpaceOnUse",
    x1: 1976.7014,
    y1: 369.3907,
    x2: 1629.6379,
    y2: 517.214,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019639869677028412810000002984343030811160243_)"
    },
    d: "M1023.697,797.412 c0.176-8.38,7.113-15.031,15.492-14.855l0.965,0.021c8.38,0.176,15.031,7.112,14.854,15.492l-0.208,9.911 c-0.177,8.38-7.113,15.03-15.493,14.854l-0.965-0.02c-8.38-0.176-15.031-7.112-14.854-15.493L1023.697,797.412z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150789791701026674360000004952665450081385119_",
    gradientUnits: "userSpaceOnUse",
    x1: 1977.9539,
    y1: 382.7717,
    x2: 1630.8892,
    y2: 530.5955,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150789791701026674360000004952665450081385119_)"
    },
    d: "M1077.563,789.594 c0.176-8.38,7.112-15.031,15.492-14.855l0.965,0.021c8.38,0.176,15.031,7.112,14.855,15.492l-0.209,9.911 c-0.176,8.38-7.112,15.031-15.492,14.855l-0.965-0.02c-8.38-0.177-15.031-7.112-14.855-15.493L1077.563,789.594z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028325950542881372980000013054981539808840326_",
    gradientUnits: "userSpaceOnUse",
    x1: 1988.1497,
    y1: 396.1538,
    x2: 1641.0862,
    y2: 543.9771,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028325950542881372980000013054981539808840326_)"
    },
    d: "M1140.375,781.964 c0.176-8.38,7.112-15.031,15.492-14.855l0.965,0.021c8.38,0.176,15.031,7.112,14.854,15.492l-0.209,9.911 c-0.176,8.38-7.112,15.031-15.492,14.854l-0.965-0.02c-8.38-0.177-15.031-7.113-14.855-15.493L1140.375,781.964z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021079288055829434840000005660527831241711234_",
    gradientUnits: "userSpaceOnUse",
    x1: 1993.875,
    y1: 409.5349,
    x2: 1646.8108,
    y2: 557.3585,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021079288055829434840000005660527831241711234_)"
    },
    d: "M1198.713,774.24 c0.176-8.38,7.112-15.031,15.492-14.854l0.965,0.02c8.38,0.176,15.031,7.112,14.855,15.493l-0.209,9.911 c-0.176,8.38-7.112,15.031-15.492,14.854l-0.965-0.02c-8.38-0.176-15.031-7.112-14.855-15.493L1198.713,774.24z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098210104177565998890000003589175763058560685_",
    gradientUnits: "userSpaceOnUse",
    x1: 1999.5951,
    y1: 418.4441,
    x2: 1652.5334,
    y2: 566.2665,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098210104177565998890000003589175763058560685_)"
    },
    d: "M1257.146,762.043 c0.176-8.38,7.112-15.031,15.493-14.855l0.965,0.02c8.38,0.176,15.031,7.112,14.854,15.493l-0.208,9.911 c-0.176,8.38-7.112,15.031-15.493,14.855l-0.965-0.021c-8.38-0.176-15.031-7.112-14.855-15.492L1257.146,762.043z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034794025553625490520000018358800074395496347_",
    gradientUnits: "userSpaceOnUse",
    x1: 2000.8483,
    y1: 436.2989,
    x2: 1653.7848,
    y2: 584.1221,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034794025553625490520000018358800074395496347_)"
    },
    d: "M1310.918,758.698 c0.176-8.38,7.113-15.031,15.493-14.854l0.965,0.02c8.38,0.176,15.031,7.112,14.854,15.493l-0.208,9.911 c-0.176,8.38-7.112,15.031-15.492,14.855l-0.965-0.021c-8.38-0.176-15.031-7.112-14.854-15.492L1310.918,758.698z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062188133100007654830000016112534325180132241_",
    gradientUnits: "userSpaceOnUse",
    x1: 2006.5721,
    y1: 449.6803,
    x2: 1659.5088,
    y2: 597.5034,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062188133100007654830000016112534325180132241_)"
    },
    d: "M1369.256,750.974 c0.177-8.38,7.112-15.031,15.493-14.855l0.965,0.02c8.38,0.176,15.031,7.112,14.855,15.492l-0.208,9.911 c-0.176,8.38-7.112,15.031-15.493,14.854l-0.965-0.02c-8.38-0.177-15.031-7.112-14.854-15.493L1369.256,750.974z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169531897554700226040000016342424679612401575_",
    gradientUnits: "userSpaceOnUse",
    x1: 2012.2964,
    y1: 458.5875,
    x2: 1665.2325,
    y2: 606.4109,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169531897554700226040000016342424679612401575_)"
    },
    d: "M1427.689,738.777 c0.176-8.38,7.112-15.031,15.492-14.854l0.965,0.02c8.38,0.176,15.031,7.112,14.854,15.493l-0.208,9.911 c-0.176,8.38-7.112,15.031-15.492,14.854l-0.965-0.02c-8.38-0.176-15.031-7.112-14.855-15.493L1427.689,738.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169545733186118897410000004075396555409759124_",
    gradientUnits: "userSpaceOnUse",
    x1: 2013.5459,
    y1: 476.4439,
    x2: 1666.4852,
    y2: 624.2659,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169545733186118897410000004075396555409759124_)"
    },
    d: "M1481.461,735.432 c0.176-8.38,7.112-15.031,15.493-14.854l0.965,0.02c8.38,0.176,15.031,7.112,14.854,15.493l-0.208,9.911 c-0.176,8.38-7.112,15.031-15.493,14.854l-0.965-0.02c-8.38-0.176-15.031-7.112-14.854-15.493L1481.461,735.432z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168078797108029207100000010723288146189478300_",
    gradientUnits: "userSpaceOnUse",
    x1: 2029.1766,
    y1: 496.6048,
    x2: 1677.1517,
    y2: 646.5411,
    gradientTransform: "matrix(0.9998 0.0211 -0.0211 0.9998 -214.2009 104.7774)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168078797108029207100000010723288146189478300_)"
    },
    d: "M1681.528,678.227l-102.625,26.188 c-7.708,1.974-12.926,9.166-12.387,17.104c0.641,9.435,1.839,20.108,3.959,19.252c3.749-1.514,164.552-38.778,164.552-38.778 L1681.528,678.227z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveCashBooking);
export default __webpack_public_path__ + "static/media/archive_cash_booking.c397143c.svg";
export { ForwardRef as ReactComponent };